/**
 * Полифил на для браузеров инвалидов
 */
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options) {
    options = options || {};

    var expires = options.expires;

    if (typeof expires === "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }

    document.cookie = updatedCookie;
}

function initForms(el) {
    $(el).each(function (i, item) {
        var form = new TurboForm(item, {
            errorClass: 'error',
            fieldLineClass: 'field',
            errorMsgClass: 'field-error-message',
            showErrorAfterInput: true,
            messageBoxSelector: '.form-success-message'
        });

        form.showPreloader = function () {
            this.form.classList.add('idle');
        };

        form.hidePreloader = function () {
            this.form.classList.remove('idle');
        };

        form.showSuccessMessage = function (message) {
            const formWrapper = this.form.closest('.form-wrapper')
            if (formWrapper) {
                formWrapper.classList.add('sent');
                var messageBox = formWrapper.querySelector('.form-success-message');
                if (messageBox) {
                    if (message) {
                        messageBox.innerHTML = message;
                    } else {
                        messageBox.innerHTML = 'Сообщение успешно отправлено';
                    }
                }
            }
        };

        form.reset = function () {
            this.unHoldForm();
            this.hidePreloader();
            this.hideOldErrors();
            this.form.reset();
            this.form.closest('.form-wrapper').classList.remove('sent');
        };
    });
}

$(function () {

    if (!getCookie('nskVSnsk2') || getCookie('nskVSnsk2') == 'undefined') {
        // $('.dep-choice-link').click();
        console.log('dep-choice-link nskVSnsk2');
        console.log(document.referrer);
        setCookie('nskVSnsk2', true, {expires: 3600 * 24});
    }

    if ((!getCookie('ufaVSufa2') || getCookie('ufaVSufa2') == 'undefined') && window.location.href === 'https://ufa.varikozanet.bitru.ru/') {
        // $('.dep-choice-link').click();
        console.log('dep-choice-link ufaVSufa2');
        console.log(document.referrer);
        setCookie('ufaVSufa2', true, {expires: 3600 * 24});
    }

    if ((!getCookie('omskVSomsk2') || getCookie('omskVSomsk2') == 'undefined') && (window.location.href === 'https://omsk.varikozanet.bitru.ru/' || window.location.href === 'https://omsk.varikozanet.bitru.ru/?force=true' || window.location.href === 'https://varikozanet.bitru.ru/')) {
        // $('.dep-choice-link').click();
        console.log('dep-choice-link omskVSomsk2');
        console.log(document.referrer);
        setCookie('omskVSomsk2', true, {expires: 3600 * 24});
    }

    if ((!getCookie('kzVSkz2') || getCookie('kzVSkz2') == 'undefined') && (window.location.href === 'https://kazan.varikozanet.bitru.ru/')) {
        // $('.dep-choice-link').click();
        console.log('dep-choice-link kzVSkz2');
        console.log(document.referrer);
        setCookie('kzVSkz2', true, {expires: 3600 * 24});
    }
    /**
     * проверка отправки событий ?_ym_debug=1
     */
    var counter = function () {
            return window.yaCounter49324336
        },
        goals = {
            'question': 'vopros_vrachu',
            'callback': 'obratniy_zvonok',
            'feedback': 'obratnaya_svyaz',
            'appointment': 'zapisatsya_na_priem',
            '#qa-form': 'qa-form',
            '#appointment-form': 'appointment-form',
            '#callback-form': 'callback-form',
            '#feedback-form': 'feedback-form',
            '#add-testimonial-form': 'add-testimonial-form'
        }, reachGoal = function (id) {
            if (counter()) {
                counter().reachGoal(id);
                console.log('Достигнута цель ' + id);
            }
        };

    initForms('.js-form');

    $('.js-popup-trigger').on('click', function () {
        if (goals.hasOwnProperty(this.data)) {
            reachGoal(goals[this.data]);
        }
    });

    $('.js-tabs-link:not(.js-tabs-link-ajax)').each(function () {
        $(this).on('click', function (e) {
            const link = $(e.target).closest('.js-tabs-link').attr('data-link')
            window.location.href = link
        })
    })

    $('.js-tabs-link-ajax').each(function () {
        $(this).on('click', function (e) {
            $('.js-tabs-link-ajax').parent().removeClass('current')
            $(this).parent().addClass('current')
            const link = $(e.target).closest('.js-tabs-link').attr('data-link')
            $.ajax({
                type: 'GET',
                url: window.location.origin + link,
                cache: false
            }).done(function (response) {
                const elementToReplace = $('.main-col').find('.' + $(response).attr('class'))
                $(response).insertAfter(elementToReplace);
                elementToReplace.remove()
            }).fail(function (error) {
                alert(error);
            });
        })
    })

    // На всякий случай
    // $('.js-tabs-link-ajax').each(function () {
    //     $(this).on('click', function (e) {
    //         $('.js-tabs-link-ajax').parent().removeClass('current')
    //         $(this).parent().addClass('current')
    //         const link = $(e.target).closest('.js-tabs-link').attr('data-link')
    //         $.ajax({
    //             type: 'GET',
    //             url: window.location.origin + link
    //         }).done(function (response) {
    //             const elementToReplace = $('.main-col').find('.' + $(response).attr('class'))
    //             console.log(elementToReplace);
    //             const prev = $(elementToReplace).prev()
    //             // elementToReplace.remove()
    //             $(response).after(prev);
    //         }).fail(function (error) {
    //             alert(error);
    //         });
    //     })
    // })

    $('[data-popup-view="search"]').one('click', function () {
        awaitModalFetch('#search-form').then(function () {
            var search = $('#search-form');
            if (search.length) {
                var form = search.find('form'),
                    input = form.find('input'),
                    list = search.find('#search-suggestions'),
                    timeout = null
                ;

                input.on('input change', function (e) {
                    clearTimeout(timeout);
                    timeout = setTimeout(sagest, 700);
                });

                function sagest() {
                    form.addClass('idle');
                    $.ajaxSetup({cache: false});
                    $.getJSON(form.attr('action') + '?' + form.serialize(), function (resp) {
                        $.ajaxSetup({cache: true});
                        if (resp.success) {
                            if (resp.html) {
                                list.html(resp.html);
                                form.addClass('suggesting');
                            } else {
                                form.removeClass('suggesting');
                            }
                        } else {
                            form.removeClass('suggesting');
                        }
                        form.removeClass('idle');
                    })
                }
            }
        })
    })

    $('.js-soc-link').on('click', function (e) {
        e = (e ? e : window.event);
        var t = (e.target ? e.target : e.srcElement),
            width = t.data - width || 800,
            height = t.data - height || 500;

        // popup position
        var px = Math.floor(((screen.availWidth || 1024) - width) / 2),
            py = Math.floor(((screen.availHeight || 700) - height) / 2);

        // open popup
        var popup = window.open(this.href, "social",
            "width=" + width + ",height=" + height +
            ",left=" + px + ",top=" + py +
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }

        return !!popup;
    });

    $(function () {
        $("#datepick").mask("00.00.0000", {
            clearIfNotMatch: true
        });
        $("#appointment-customer-tel2").each((i, input) => {
            initIMask(input)
        });
        $(".js-input-phone").each((i, input) => {
            initIMask(input)
        });
        $("input[type='tel']").each((i, input) => {
            initIMask(input)
        });
    });

    var docDate = '';
    var docTime = '';
    var docID = '';
    var docName = '';
    var docDateLong = '';

    function resetAppointmentForm() {
        $('#appointment-form-confirm .form-success-done').css({'display': 'none'});
        $('#appointment-form-confirm .suggest-text').css({'display': 'block'});
        $('#appointment-form-confirm .validate').css({'display': 'grid'});
        $('#appointment-form-confirm .footer-off').css({'display': 'flex'});
    }

    function awaitModalFetch(modalSelector) {
        return new Promise(function (resolve, reject) {
            if ($(modalSelector).length) {
                resolve()
            }
            window.addEventListener('modalFetched', function () {
                resolve()
            }, {once: true})
        })
    }

    function awaitConfirmForm(cb) {
        awaitModalFetch("#appointment-customer-doc-date span").then(cb)
    }

    function insertDataInConfirmForm() {
        $('#appointment-customer-doc-date span').text(docDateLong);
        $('#appointment-customer-doc span').text(docName);
        $('#appointment-customer-doc-time span').text(docTime);
    }

    $('body').on('click', '#doc-choice', function () {
        resetAppointmentForm()
        awaitModalFetch('#doc-choice').then(function () {
            $.ajax({
                method: "GET",
                url: "https://api.varikozanet.bitru.ru/api/",
                data: {action: '4'}
            })
                .done(function (data) {
                    $('button.back-button-doc-form').attr('data-popup', '#doc-or-date-choice');
                    $('#docs-form').find('.staff-person-photos').remove();
                    $('#docs-form .staff-persons-group-items').append(data);
                    $('#docs-form .services-item-title span').text('Выберите доктора');
                    $("#docs-form .staff-person").click(function () {
                        docName = $(this).find('.staff-person-name').text();
                        $('.calendar-form-link').click();
                        docID = $(this).attr('id');
                        awaitModalFetch('#calendar-form').then(function () {
                            $.ajax({
                                method: "GET",
                                url: "https://api.varikozanet.bitru.ru/api/",
                                data: {action: '5', doc_id: docID},
                            })
                                .done(function (dataJSON) {
                                    $('button.back-button-calendar-form').attr('data-popup', '#docs-form');
                                    var arrayDates = $.parseJSON(dataJSON);
                                    $('#calendar0').fullCalendar('destroy');
                                    $('#calendar0').fullCalendar({
                                        height: 300,
                                        header: {
                                            left: 'prev',
                                            center: 'title',
                                            right: 'next'
                                        },
                                        dayClick: function (date) {
                                            docDate = $.fullCalendar.formatDate(date, "YYYY-MM-DD");
                                            if ($.inArray(docDate, arrayDates) != -1) {
                                                $('.day-doc-time-form-link').click();
                                                awaitModalFetch('#day-doc-time-form').then(function () {
                                                    $.ajax({
                                                        method: "GET",
                                                        url: "https://api.varikozanet.bitru.ru/api/",
                                                        data: {action: '6', doc_day: docDate, doc_id: docID}
                                                    })
                                                        .done(function (data) {
                                                            $('button.back-button-day-doc-time-form').attr('data-popup', '#calendar-form');
                                                            $('#day-doc-time-form').find('.staff-person').remove();
                                                            $('#day-doc-time-form .staff-persons-group-items').append(data);
                                                            docDateLong = $.fullCalendar.formatDate(date, "DD MMMM YYYY");
                                                            $('#day-doc-time-date-str').parent('.contacts-schedule').closest('.field').css('display', 'block');
                                                            $('#day-doc-time-date-str span').text(docDateLong + ' г.');

                                                            $('#day-doc-time-doc-str').parent('.contacts-schedule').closest('.field').css('display', 'block');
                                                            $('#day-doc-time-doc-str span').text(docName);


                                                            $("#day-doc-time-form .publications-item-thumb-1").click(function (e) {
                                                                e.preventDefault()
                                                                e.stopPropagation()
                                                                docTime = $(this).find('span').text();
                                                                $('.appointment-form-confirm-link').click();
                                                                awaitConfirmForm(function () {
                                                                    insertDataInConfirmForm()
                                                                    $('button.back-button-appointment-form-confirm').attr('data-popup', '#day-doc-time-form');
                                                                })
                                                            });
                                                        });
                                                })
                                            } else {
                                                console.log("not in array");
                                            }
                                        },
                                        dayRender: function (date, cell) {
                                            var date = new Date(date);
                                            var str = date.toISOString();
                                            str = str.substr(0, str.length - 14);
                                            if ($.inArray(str, arrayDates) != -1) {
                                                $('#calendar-form .fc-content-skeleton [data-date="' + str + '"]').attr('data-active', 'true')
                                            }
                                        }
                                    });
                                });
                        })
                    });
                });
        })
    });

    $('body').on('click', '#date-choice', function () {
        resetAppointmentForm()
        awaitModalFetch('#calendar-form').then(function () {
            $.ajax({
                method: "GET",
                url: "https://api.varikozanet.bitru.ru/api/",
                data: {action: '1'},
            })
                .done(function (dataJSON) {
                    $('button.back-button-calendar-form').attr('data-popup', '#doc-or-date-choice');
                    var arrayDates = $.parseJSON(dataJSON);
                    $('#calendar0').fullCalendar('destroy');
                    $('#calendar0').fullCalendar({
                        height: 300,
                        header: {
                            left: 'prev',
                            center: 'title',
                            right: 'next'
                        },
                        dayClick: function (date) {
                            docDate = $.fullCalendar.formatDate(date, "YYYY-MM-DD");
                            if ($.inArray(docDate, arrayDates) != -1) {
                                $('.day-doc-time-form-link').click();
                                awaitModalFetch('#day-doc-time-form').then(function () {
                                    $.ajax({
                                        method: "GET",
                                        url: "https://api.varikozanet.bitru.ru/api/",
                                        data: {action: '2', doc_day: docDate}
                                    })
                                        .done(function (data) {
                                            $('button.back-button-day-doc-time-form').attr('data-popup', '#calendar-form');
                                            $('#day-doc-time-form').find('.staff-person').remove();
                                            $('#day-doc-time-form .staff-persons-group-items').append(data);
                                            docDateLong = $.fullCalendar.formatDate(date, "DD MMMM YYYY");
                                            $('#day-doc-time-doc-str').parent('.contacts-schedule').closest('.field').css('display', 'none');
                                            $('#day-doc-time-date-str').parent('.contacts-schedule').closest('.field').css('display', 'block');
                                            $('#day-doc-time-date-str span').text(docDateLong + ' г.');
                                            $('#day-doc-time-form .publications-item-thumb-1').attr('data-popup-view', 'doc_form');
                                            $("#day-doc-time-form .publications-item-thumb-1").click(function () {
                                                $('.docs-time-form-link').click();
                                                docTime = $(this).find('span').text();
                                                awaitModalFetch('#docs-form').then(function () {
                                                    $.ajax({
                                                        method: "GET",
                                                        url: "https://api.varikozanet.bitru.ru/api/",
                                                        data: {action: '3', doc_day: docDate, doc_time: docTime}
                                                    })
                                                        .done(function (data) {
                                                            $('button.back-button-doc-form').attr('data-popup', '#day-doc-time-form');
                                                            $('#docs-form').find('.staff-person-photos').remove();
                                                            $('#docs-form .staff-persons-group-items').append(data);
                                                            // $('#docs-form .services-item-title span').text('Дата и время приема: '+docDateLong+' г. в '+docTime);
                                                            $("#docs-form .staff-person").click(function () {
                                                                $('.appointment-form-confirm-link').click();
                                                                // alert($(this).find('.staff-person-name').text());
                                                                docID = $(this).attr('id');
                                                                docName = $(this).find('.staff-person-name').text();
                                                                // $('#appointment-form-confirm .services-item-title span').text('Дата, время приема, доктор: '+docDateLong+' г. в '+docTime+' - '+docName);
                                                                awaitConfirmForm(function () {
                                                                    insertDataInConfirmForm()
                                                                    $('button.back-button-appointment-form-confirm').attr('data-popup', '#docs-form');
                                                                })
                                                            });
                                                        });
                                                })
                                            });
                                        });
                                })
                            } else {
                                console.log("not in array");
                            }
                        },
                        dayRender: function (date, cell) {
                            var date = new Date(date);
                            var str = date.toISOString();
                            str = str.substr(0, str.length - 14);
                            if ($.inArray(str, arrayDates) != -1) {
                                $('#calendar-form .fc-content-skeleton [data-date="' + str + '"]').attr('data-active', 'true')
                            }
                        }
                    });
                });
        })
    });

    $('body').on('click', '.send-sms', function (e) {
        e.preventDefault()
        if ($(".validate").valid()) {
            var cellPhone = $('#appointment-customer-tel2').val();
            $.ajax({
                method: "GET",
                url: "https://api.varikozanet.bitru.ru/api/",
                data: {action: '7', cell_phone: cellPhone}
            })
                .done(function (dataJSON) {
                    var arraySMS = $.parseJSON(dataJSON);
                    if (arraySMS.status == 'success') {
                        $('#appointment-form-confirm .footer-off').css({'display': 'none'});
                        $('#appointment-form-confirm .form-success').css({'display': 'block'});
                        $("#appointment-form-confirm form input").prop('disabled', true);
                        $('.record-ariadna').click(function () {
                            var codeConfirm = $('#appointment-customer-code').val();
                            var birthDay = $('#datepick').val();
                            var lastName = $('#appointment-customer-last-name').val();
                            var firstName = $('#appointment-customer-first-name').val();
                            var secondName = $('#appointment-customer-second-name').val();
                            $.ajax({
                                method: "GET",
                                url: "https://api.varikozanet.bitru.ru/api/",
                                data: {
                                    action: '8'
                                    , code: codeConfirm
                                    , id_session: arraySMS.id_session
                                    , last_name: lastName
                                    , first_name: firstName
                                    , second_name: secondName
                                    , birth_day: birthDay
                                    , cell_phone: cellPhone
                                    , doc_id: docID
                                    , doc_day: docDate
                                    , doc_time: docTime
                                }
                            })
                                .done(function (dataJSON) {
                                    var arraySMSCode = $.parseJSON(dataJSON);
                                    if (arraySMSCode.status == 'success') {
                                        // $('#appointment-form-confirm .popup-close-button').click();
                                        $('#appointment-form-confirm .form-wrapper--data').css({'display': 'none'});
                                        $('#appointment-form-confirm .footer-off').css({'display': 'none'});
                                        $('#appointment-form-confirm .form-success').css({'display': 'none'});
                                        $('#appointment-form-confirm .suggest-text').css({'display': 'none'});
                                        $('#appointment-form-confirm .validate').css({'display': 'none'});
                                        $("#appointment-form-confirm form input").prop('disabled', false);
                                        $("#appointment-form-confirm input").val('');
                                        $('#appointment-form-confirm .form-success-done').css({'display': 'block'});
                                        $('#appointment-form-confirm .form-success-done .form-success-message p').html('Ждем Вас ' + docDateLong + ' в ' + docTime + '  в клинике "Варикоза нет" по адресу ' + $('.top-bar-content .dep-choice-link').text() + '<br> Не забудьте взять паспорт.');

                                        checkFormForCalltouch($('#appointment-form-confirm form')[0], {
                                            phone: cellPhone,
                                            name: lastName + ' ' + firstName + ' ' + secondName
                                        }, false);

                                        dispatchGoalEvent('sajt-uspeshnaya-zapis-na-priem')
                                    } else if (arraySMSCode.status == 'fail') {
                                        $('#appointment-form-confirm .form-success-message .field-error-message').text('Код не верный');
                                        $('#appointment-form-confirm .form-success-message .field-error-message').css('display', 'contents');
                                    }
                                });
                        });
                    } else {
                        console.log(arraySMS.status);
                        console.log(arraySMS.error);
                        console.log(arraySMS.error_desc);
                    }
                });
        }

    });


    $('body').on('click', '.send-callback', function (e) {
        e.preventDefault()
        const target = $(e.target);
        const form = target.closest('.validate-callback')
        if (form.valid()) {
            var cellPhoneCallback = $('.js-input-phone', form).val();
            var cellNameCallback = $('input[name="first_name"]', form).val();
            $.ajax({
                method: "POST",
                url: "/mango/send_callback/",
                data: {phone: cellPhoneCallback, first_name: cellNameCallback}
            })
                .done(function (dataXML) {
                    if (dataXML.status == 'success') {
                        window._popup.currentPopup = $('#appointment-new-form')
                        window._popup.show()
                        $('#appointment-new-form .js-success-message').show();
                        $('#appointment-new-form .js-popup-appointment-content').hide();
                        $('#appointment-new-form .js-popup-close').click(function () {
                            setTimeout(function () {
                                $('#appointment-new-form .js-success-message').hide();
                                $('#appointment-new-form .js-popup-appointment-content').show();
                            }, 500);
                        });
                        sendFormToCalltouch(form[0]);
                    } else {
                        console.log(dataXML);
                    }
                });
        }
    });

    $('.send-callback-promo').click(function (e) {
        e.preventDefault()
        const target = $(e.target);
        const form = target.closest('.validate-callback')
        if (form.valid()) {
            var cellPhoneCallback = $('.js-input-phone', form).val();
            $.ajax({
                method: "GET",
                url: "https://api.varikozanet.bitru.ru/api/",
                data: {action: '9', cell_phone: cellPhoneCallback}
            })
                .done(function (dataXML) {
                    var result_callback = $(dataXML).find('property_simple[key="startresult"]').attr('name');
                    if (result_callback == 'success') {
                        $('#timer-record-form .form-success').show();
                        $('#timer-record-form form').hide();
                        $('#timer-record-form .js-popup-close').click(function () {
                            setTimeout(function () {
                                $('#timer-record-form .form-success').hide();
                                $('#timer-record-form form').show();
                            }, 500);
                        });
                        checkFormForCalltouch(form[0], {phone: cellPhoneCallback}, false);
                    } else {
                        console.log(dataXML);
                    }
                });
        }
    });

    $(document).mouseleave(function () {
        if (!sessionStorage.getItem('isAppointmentPopupOpened')) {
            sessionStorage.setItem('isAppointmentPopupOpened', "1")
            setTimeout(function () {
                if ($('.popup.show').length) return;
                $('.appointment-new-form-link').click();
                $(".js-input-phone").blur();
            }, 30000);
        }
    });

    $('.callback-bt').click(function () {
        $('.appointment-new-form-link').click();
        $(".js-input-phone").blur();
    })

    // $(".js-input-phone").click(function () {
    //     $(this).removeAttr("readonly").focus();
    // });

    $('a[href="#appointment-new-form"]').click(function () {
        $(".js-input-phone").blur();
    });
    $('.js-input-phone').on('focus', 'input', function () {
        $(this).blur();
    });

});
